var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-modal-input',{staticClass:"Info.Page.VerifySpvPass.Class",attrs:{"hideFormSuccess":"","title":_vm.Info.Page.VerifySpvPass.Title,"width":500},on:{"init":_vm.handleInit,"submit":_vm.handleSubmit}},[_c('kst-input',{attrs:{"load-on-focus":"","field":"spv_passwd","data":_vm.userData,"catalog":_vm.Catalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }